import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { Router, UrlSerializer } from '@angular/router';
import { BdxHttpModule } from '@buildium/ngx-app-utility/dist';
import * as Sentry from '@sentry/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { PublicGlobalErrorHandler } from './core/public-global-error-handler';

// In general, we should NOT be importing services from other apps, but these will eventually come from a shared package
import { ToastMessageModule } from '../../../../src/app/core/toast-message/toast-message.module';
import { LowerCaseUrlSerializer } from '../../../../src/app/core/routes/lower-case-url-serializer';
import { SentryLoaderService } from '../../../../src/app/services/sentry-loader.service';
import { FeatureFlagService } from '../../../../src/app/services/feature-flag.service';
import { ErrorExtractorService } from '../../../../src/app/services/error-extractor.service';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BdxHttpModule,
        CoreModule,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        ToastMessageModule
    ],
    providers: [
        ErrorExtractorService,
        FeatureFlagService,
        {
            provide: ErrorHandler,
            useClass: PublicGlobalErrorHandler
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (sentryLoaderService: SentryLoaderService) => {
                return () => {
                    sentryLoaderService.loadSentry();
                };
            },
            deps: [SentryLoaderService],
            multi: true,
        },
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
